"use client";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { type ReactNode, useState } from "react";

export type QueryProviderProps = {
  children: ReactNode;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  },
});

export function QueryProvider({ children }: Readonly<QueryProviderProps>) {
  const [queryClientState] = useState(queryClient);

  return (
    <QueryClientProvider client={queryClientState}>
      <ReactQueryDevtools />
      {children}
    </QueryClientProvider>
  );
}
